import React, { useEffect, useState, useRef, useContext } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { Typography, Button, Row, Col, Modal } from "antd";
import { CartContext } from "../context/CartContext";
import { FaInstagram, FaFacebook, FaYoutube } from "react-icons/fa";
import SummaryApi from "../common/index";
import "../Styles/UserStylings/ProductDetails.css";

const { Title, Text, Paragraph } = Typography;

function ProductDetails() {
  const { id } = useParams();
  const BASE_URL = process.env.REACT_APP_BACKEND_URL;
  const [product, setProduct] = useState(null);
  const { addToCart } = useContext(CartContext);

  const zoomRef = useRef();
  const defaultImage = "/images/default.jpg";
  const [displayImage, setDisplayImage] = useState(defaultImage);
  const [isImageModalOpen, setIsImageModalOpen] = useState(false);
  const [isVideoModalOpen, setIsVideoModalOpen] = useState(false);
   const isValidLink = (link) => {
    return typeof link === "string" && link.trim() !== "";
  };
  useEffect(() => {
    const fetchProduct = async () => {
      try {
        const res = await axios.get(
          SummaryApi.getProductById(id).url.replace(":id", id)
        );
        const productData = res.data.product || res.data;
         console.log("Fetched product:", productData); 
        setProduct(productData);

        if (Array.isArray(productData.images) && productData.images.length > 0) {
          setDisplayImage(`${BASE_URL}${productData.images[0]}`);
        } else {
          setDisplayImage(defaultImage);
        }
      } catch (err) {
        console.error("Error fetching product details", err);
      }
    };
    fetchProduct();
  }, [id, BASE_URL]);

  if (!product) return <p>Loading...</p>;

  const discount =
    product.actual_price && product.actual_price > product.selling_price
      ? Math.round(
          ((product.actual_price - product.selling_price) / product.actual_price) * 100
        )
      : 0;

  const openImageModal = () => setIsImageModalOpen(true);
  const closeImageModal = () => setIsImageModalOpen(false);

  return (
    <div className="pd-page">
      <Row gutter={[32, 32]} className="pd-wrapper" justify="center">
        {/* ===== Left: Product Image & Thumbnails ===== */}
        <Col xs={24} sm={24} md={10} className="pd-image-section">
          <div className="pd-image-card">
            {discount > 0 && <div className="pd-discount-tag">{discount}% OFF</div>}

            {/* Main Image */}
            <div className="pd-main-image-wrapper" ref={zoomRef} onClick={openImageModal}>
              <img
                src={displayImage}
                alt={product.name}
                className="pd-main-image"
                onError={(e) => (e.target.src = defaultImage)}
              />
            </div>

            {/* Thumbnails Row */}
            <div className="pd-thumbnails-wrapper" >
              {Array.isArray(product.images) &&
                product.images.map((img, index) => (
                  <div
                    key={index}
                    style={{borderRadius:"12px"}}
                    className={`pd-thumb-wrapper ${
                      displayImage === `${BASE_URL}${img}` ? "active" : ""
                    }`}
                    onClick={() => setDisplayImage(`${BASE_URL}${img}`)}
                  >
                    <img
                      src={`${BASE_URL}${img}`}
                      alt={`Thumbnail ${index + 1}`}
                      style={{borderRadius:"12px"}}
                      onError={(e) => (e.target.src = defaultImage)}
                    />
                  </div>
                ))}

              {product.video && (
                <div className="pd-thumb-wrapper pd-video-thumb" onClick={() => setIsVideoModalOpen(true)}>
                  <img
                    src={product.images?.length ? `${BASE_URL}${product.images[0]}` : defaultImage}
                    alt="Video thumbnail"
                  />
                  <div className="pd-play-overlay">
                    <i className="fas fa-play-circle play-icon"></i>
                  </div>
                </div>
              )}
            </div>

            <p className="pd-click-view">Click image to view larger</p>

            {/* Video Modal */}
            {product.video && (
              <Modal
                open={isVideoModalOpen}
                onCancel={() => setIsVideoModalOpen(false)}
                footer={null}
                centered
                width={800}
                className="pd-video-modal"
              >
                <video
                  src={`${BASE_URL}${product.video}`}
                  controls
                  autoPlay
                  className="pd-video-player"
                />
              </Modal>
            )}
          </div>
        </Col>

        {/* ===== Right: Product Info ===== */}
        <Col xs={24} sm={24} md={14}>
          <div className="pd-info-card">
            <Title level={3} className="pd-title">{product.name}</Title>
            <div className="pd-rating">
              <div className="stars">
                {Array.from({ length: 5 }, (_, i) => (
                  <span key={i} className={`star ${i < (product.rating || 5) ? "filled" : ""}`}>★</span>
                ))}
              </div>
              <span className="pd-rating-value">({product.rating || 5})</span>
            </div>
            <Paragraph className="pd-category"><Text strong>Category:</Text> {product.category}</Paragraph>
            <Paragraph className="pd-seller"><Text strong>Seller:</Text> {product.seller?.name || "MedKart Seller"}</Paragraph>
            <Paragraph className="pd-store-pickup"><Text strong>Delivery Option:</Text> {product.deliveryOption === "store_pickup" ? " Store Pickup Available" :product.deliveryOption === "home_delivery" ? "Home Delivery Available" :product.deliveryOption === "both" ? "Store Pickup/Home Delivery" : "Delivery information not available"}</Paragraph>
            <Paragraph className="pd-description"><Text strong>Description:</Text> {product.description}</Paragraph>
                      {/* Video Links Section */}
{/* Video Links Section */}
{/* Video Links Section */}
{/* Video Links Section */}
{/* Display only uploaded social links */}
{(isValidLink(product?.facebook) ||
  isValidLink(product?.instagram) ||
  isValidLink(product?.youtube)) && (
  <div className="pd-video-links" style={{ marginTop: 16 }}>
    <Paragraph strong style={{ fontWeight: "bolder" }}>
      Video Links
    </Paragraph>

    <div className="social-icons-row">
      {isValidLink(product?.facebook) && (
        <a
          href={product.facebook}
          target="_blank"
          rel="noopener noreferrer"
          className="social-icon-item"
        >
          <FaFacebook className="social-icon fb" />
        </a>
      )}

      {isValidLink(product?.instagram) && (
        <a
          href={product.instagram}
          target="_blank"
          rel="noopener noreferrer"
          className="social-icon-item"
        >
          <FaInstagram className="social-icon ig" />
        </a>
      )}

      {isValidLink(product?.youtube) && (
        <a
          href={product.youtube}
          target="_blank"
          rel="noopener noreferrer"
          className="social-icon-item"
        >
          <FaYoutube className="social-icon yt" />
        </a>
      )}
    </div>
  </div>
)}





            <div className="pd-pricing">
              <Text strong className="pd-selling-price">₹{product.selling_price}</Text>
              {discount > 0 && <Text delete className="pd-actual-price">₹{product.actual_price}</Text>}
            </div>
            <Paragraph className="pd-stock">
              <Text strong>Stock:</Text>{" "}
              <Text type={product.stock > 0 ? "success" : "danger"}>
                {product.stock > 0 ? `In Stock (${product.stock} Available)` : "Out of Stock"}
              </Text>
            </Paragraph>
            <Button
              type="primary"
              size="large"
              disabled={product.stock <= 0}
              className="pd-add-to-cart-btn"
              onClick={() => addToCart(product)}
            >
              {product.stock > 0 ? "Add to Cart" : "Unavailable"}
            </Button>
  
          </div>
        </Col>
{/* Display only the uploaded links */}

      </Row>
        {/* Social Media Links */}
{/* Social Media Links */}
{/* Social Media Links */}



      {/* Image Modal */}
   <Modal
  open={isImageModalOpen}
  onCancel={closeImageModal}
  footer={null}
  centered
  width={"60vw"}
  bodyStyle={{
    padding: 0,
    margin: 0,
    height: "60vh",
    background: "black",
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
  }}
>
  <img
    src={displayImage}
    alt={product.name}
    style={{
      maxWidth: "100%",
      maxHeight: "100%",
      objectFit: "contain"
    }}
    onError={(e) => (e.target.src = defaultImage)}
  />
</Modal>

    </div>
  );
}

export default ProductDetails;